import { ChannelModel } from "../../../models/ChannelModel";
import { ChannelType } from "../ChannelProvider";

export const PLINKChannel: ChannelModel = {
    thumbnail: "plink.png",
    code: "plink",
    type: ChannelType.EWALLET,
    payment_type: "plink",
    title: "Plink",
    subtitle: "Pembayaran menggunakan Plink",
    image_url: "/assets/plink.png",
    hows: [
        {
            name: "Plink",
            steps: [
                "Klik tombol bayar untuk diarahkan ke halaman pembayaran Plink.",
                "Selesaikan pembayaran sesuai instruksi yang ditampilkan.",
                "Pembayaran Anda telah berhasil.",
            ],
        },
    ],
};
